module.exports = angular.module("tfApp.strategy.strategy-service", [])
                        .service("strategyService", strategyService)
                        .name;

/** @ngInject */
function strategyService($http, $q, simpleModalService, userConfig, chainService) {

    let chain;

    const optionsChain = async (underlying) => {
        if (underlying == null) {
            return null;
        } else if (chain == null) {
            chain = chainService(underlying);
        } else {
            const currentChain = await chain;
            if (currentChain.code !== underlying) {
                chain = chainService(underlying);
            }
        }
        return chain;
    };

    async function list() {
        const response = await $http.get('/tradefloor/api/strategy');
        return response.data;
    }

    function updateStrategy(strategy) {
        const equityTrades = strategy.equityTradeDetails.map((position) => {
            return {
                code: position.underlyingCode,
                quantity: position.quantity,
                id: position.id
            }
        });

        const optionsTrades = strategy.tradeDetails.map((position) => {
            return {
                code: position.code,
                quantity: position.quantity,
                id: position.id
            }
        });

        const trades = equityTrades.concat(optionsTrades);

        strategy.trades = trades;

        return $http.post("/tradefloor/api/strategy/" + strategy.id + "/trades", trades)
            .then(function (response) {
                strategy.trades = response.data;
                return strategy;
            })
    }

    async function processStrategyResult(strategy, result) {
        const baseStrategy = result.strategyMovements[(result.strategyMovements.length - 1) / 2];
        baseStrategy.cashEffect = result.buyingPower;
        baseStrategy.netTheo = result.netTheo;
        baseStrategy.premium = result.premium;
        baseStrategy.breakEvenPoints = result.breakEvenPoints;

        strategy.tradeDetails = result.trades;
        strategy.positions = result.trades;
        strategy.equityTradeDetails = result.equityTrades;

        strategy.tradeDetails.forEach(function (t) {
            t.quantity = t.quantity / strategy.scaleFactor;
        });
        strategy.equityTradeDetails.forEach(function (t) {
            t.quantity = t.quantity / strategy.scaleFactor;
        });

        if (strategy.tmc) {
            strategy.tradeDetails.forEach((t) => {
                t.total = t.quantity * strategy.scaleFactor;
            });

            let cvf = 100;
            const chain = await optionsChain(strategy.underlying);
            if (chain != null) {
                cvf = chain.cvf
            }

            strategy.equityTradeDetails.forEach((t) => {
                t.total = t.quantity * strategy.scaleFactor * cvf;
            });
        } else {
            strategy.tradeDetails.forEach((t) => {
                t.total = t.quantity;
            });

            strategy.equityTradeDetails.forEach((t) => {
                t.total = t.quantity;
            });
        }

        return {
            baseStrategy: baseStrategy,
            strategy: strategy,
            gcd: result.gcd,
            netTheo: result.netTheo,
            strategyMovements: result.strategyMovements,
            timeDecay: result.timeDecay,
            maxLoss: result.maxLoss,
            maxGain: result.maxGain,
            buyingPower: result.buyingPower,
            payoffSummary: result.payoffSummary
        };
    }

    async function strategySummaries(portfolioId, strategies) {
        const strategyIds = strategies.map(s => s.id);

        const response = await $http.post(`/tradefloor/api/strategy/portfolio/${portfolioId}/summaries`, strategyIds);
        const data = response.data;
        return data;
    }

    async function portfolioStrategyResults(portfolio, strategy, timeSeries, pricePoints, volUp, volDown) {

        timeSeries = timeSeries == null ? 3 : timeSeries;
        pricePoints = pricePoints == null ? 15 : pricePoints;
        volUp = volUp == null ? 0.5 : volUp;
        volDown = volDown == null ? 0.5 : volDown;
        strategy.scaleFactor = strategy.scaleFactor == null ? 1 : strategy.scaleFactor;

        const trades = strategy.trades || [];

        const positions = trades.map(tr => {
            const qty = tr.quantity;
            return {
                id: tr.id,
                c: tr.code,
                p: tr.price,
                q: qty * strategy.scaleFactor
            };
        });

        const optionsTrades = positions.filter((tr) => tr.c.length > 3);

        const equityTrades = positions.filter((tr) => tr.c.length === 3)
                                      .map((tr) => {
                                          return {
                                              id: tr.id,
                                              issuer: tr.c,
                                              price: tr.p,
                                              quantity: tr.q
                                          }
                                      });
        const request = {
            id: portfolio.id,
            marginMultiplier: portfolio.marginMultiplier,
            eodEtoLedger: portfolio.eodEtoLedger,
            currentEtoLedger: portfolio.currentEtoLedger,
            eodEquityLedger: portfolio.eodEquityLedger,
            currentEquityLedger: portfolio.currentEquityLedger,
            eodCmaBalance: portfolio.eodCmaBalance,
            currentCmaBalance: portfolio.currentCmaBalance,
            positions: portfolio.positions || [],
            pinnedTrades: portfolio.pinnedTrades || [],
            equityPositions: portfolio.equityPositions || [],
            trades: optionsTrades,
            equityTrades,
            isTmcScenario: strategy.tmc
        };

        const response = await $http.post("/tradefloor/api/strategy/detail/" + timeSeries + "/" + pricePoints + "?volUpPercentage=" + volUp + "&volDownPercentage=" + volDown, request);
        const data = response.data;
        return await processStrategyResult(strategy, data);
    }

    async function strategyResults(strategy, timeSeries, pricePoints, volUp, volDown) {

        const marginMultiplier = userConfig.broker === 'IV' ? 1.2 : 1;

        const dummyPortfolio = {
            id: null,
            marginMultiplier: marginMultiplier,
            eodEtoLedger: 0,
            currentEtoLedger: 0,
            eodEquityLedger: 0,
            currentEquityLedger: 0,
            eodCmaBalance: 0,
            currentCmaBalance: 0,
            positions: [],
            trades: [],
            pinnedTrades: [],
            futurePositions: [],
            equityPositions: [],
            equityTrades: []
        };

        return await portfolioStrategyResults(dummyPortfolio, strategy, timeSeries, pricePoints, volUp, volDown);
    }

    /* Tells the back end to convert the strategy to a TMC, but does not return the updated strategy */
    async function makeTmc(strategy, isWhatIf, portfolioId) {
        var url;
        if (isWhatIf) {
            strategy.lots = 1;
            url = `/tradefloor/api/portfolio/${portfolioId}/whatifs/${strategy.id}/tmc`;
        } else {
            url = `/tradefloor/api/strategy/${strategy.id}/tmc`;
        }
        try {
            await $http.post(url)
        } catch (error) {
            const message = error.data.error;
            await simpleModalService.error(null, message);
            return Promise.reject(message);
        }
    }

    async function unmakeTmc(strategy, isWhatIf, portfolio) {
        let url;
        if (isWhatIf) {
            throw Error("Phil didn't have time to implement this call yet");
        } else {
            url = `/tradefloor/api/strategy/${strategy.id}/tmc`;
        }
        return await $http.delete(url)
    }

    /* Converts the supplied Strategy into the TMC version if it is valid */
    async function strategyToTmc(strategy, hideError) {
        // Covers both strategies and WhatIfs!
        const scaleFactor = strategy.scaleFactor || strategy.lots || 1;

        const trades = strategy.trades
                               .map(tr => {
                                   return {
                                       id: tr.id,
                                       code: tr.code,
                                       quantity: tr.quantity * scaleFactor
                                   }
                               });
        const request = {
            trades
        };
        const url = `/tradefloor/api/strategy/build-tmc`;
        try {
            const response = await $http.post(url, request);
            return response.data;
        } catch (error) {
            if (!hideError) {
                const message = error.data.error;
                await simpleModalService.error(null, message);
            }
            return Promise.reject(message);
        }
    }

    async function createStrategy(underlying, trades, tmc, name, description, scaleFactor) {
        var newStrategy = {
            underlying: underlying,
            name: name,
            description: description,
            trades: trades || [],
            tmc: tmc,
            scaleFactor: scaleFactor
        };
        return create(newStrategy);
    }

    async function create(strategy) {
        const response = await $http.put('/tradefloor/api/strategy', strategy);
        return response.data;
    }

    function clone(strategy) {
        const name = `Copy of ${strategy.name}`;
        const trades = strategy.trades.map(tr => Object.assign({}, { code: tr.code, quantity: tr.quantity}));
        const newStrategy = {
            name,
            underlying: strategy.underlying,
            trades,
            tmc: strategy.tmc || false,
            description: strategy.description,
            gcd: strategy.gcd,
            scaleFactor: strategy.scaleFactor
        };
        return create(newStrategy);
    }

    async function deleteStrategy(strategy) {
        return $http.delete('/tradefloor/api/strategy/' + strategy.id)
    }

    return {
        updateStrategy: updateStrategy,
        portfolioStrategyResults: portfolioStrategyResults,
        strategyResults: strategyResults,
        strategySummaries: strategySummaries,
        makeTmc: makeTmc,
        unmakeTmc: unmakeTmc,
        createStrategy: createStrategy,
        clone: clone,
        deleteStrategy: deleteStrategy,
        list: list,
        strategyToTmc: strategyToTmc
    }
}
